var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listData.length > 0)?_c('div',{staticClass:"noti-list"},_vm._l((_vm.listData),function(item){return _c('NotiItem',{key:item.id,attrs:{"itemData":item}})}),1):_c('div',{staticClass:"empty-list flex-center"},[_vm._v("お知らせはまだないよ")])}
var staticRenderFns = []

export { render, staticRenderFns }